import EnumType from "@/app/shared/EnumType.js";

const values =  {
  Update: 0, 
  UpdateWriteOff: 1,
  Reconduct: 2
};

export default EnumType.generate(values, "MRMR.UpdateType.");